var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings && _vm.settings.base_options && _vm.settings.base_options.show_language_changer)?_c('v-list',{attrs:{"light":""}},[_c('v-list-item',{staticClass:"locale-changer"},[_vm._l((_vm.availableLanguages),function(ref,i){
var key = ref.key;
var label = ref.label;
return [_c('a',{class:{ 'active': _vm.getLanguageKey === key },on:{"click":function($event){return _vm.changeLocale(key)}}},[_vm._v(" "+_vm._s(label)+" ")])]})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }